import {Stack, SxProps, Typography} from '@mui/material';
import {ReactComponent as LockedImage} from '../../images/locked.svg';
import {translations} from '../../i18n/translations';
import {useTranslation} from 'react-i18next';

export const pageWrapperSx: SxProps = {
  width: '100%',
  height: '80vh',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

const textSx: SxProps = {
  fontSize: '20px',
  fontWeight: 600,
  lineHeight: 'normal',
  color: 'var(--dcm-gray)',
  maxWidth: '310px',
  textAlign: 'center',
  marginTop: '16px',
};

const MissingPermissionsScreen = () => {
  const {t} = useTranslation();

  return (
    <Stack sx={pageWrapperSx}>
      <LockedImage />
      <Typography sx={textSx}>
        {t(translations.office.permissions.access_denied_message)}
      </Typography>
    </Stack>
  );
};

export default MissingPermissionsScreen;
